import { useState } from 'react';
import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

import { CourseInView } from './Courses';

interface Props {
  course: CourseInView;
}

const CoursesUserActionRequestAccess = ({ course }: Props) => {
  const { messages } = useReduxState();

  const [hasRequest, setHasRequest] = useState(course.pendingAccessRequest);

  const handleRequestAccess = async () => {
    try {
      await api.post(`/admin/courses/${course.id}/request-access`);
      setHasRequest(true);

      return true;
    } catch (err) {
      return false;
    }
  };

  return (
    <ConfirmButton
      actionText={messages.commonSend}
      buttonIsRounded={true}
      buttonSize="header"
      buttonStyle={{
        fontSize: '1.3rem',
        padding: '6px 12px 7px'
      }}
      buttonText={
        hasRequest
          ? messages.commonAccessRequested
          : messages.courseAccessRequestActionMakeRequest
      }
      confirmText={messages.courseAccessRequestDescription}
      confirmTitle={messages.courseAccessRequestActionMakeRequest}
      disabled={hasRequest}
      onConfirm={handleRequestAccess}
      stopPropagation={true}
      successMessage={messages.courseAccessRequestActionMakeRequestSent}
    />
  );
};

export default CoursesUserActionRequestAccess;
